import { render, staticRenderFns } from "./ServicePortfolioSection.vue?vue&type=template&id=03f3a362&scoped=true"
import script from "./ServicePortfolioSection.vue?vue&type=script&lang=js"
export * from "./ServicePortfolioSection.vue?vue&type=script&lang=js"
import style0 from "./ServicePortfolioSection.vue?vue&type=style&index=0&id=03f3a362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3a362",
  null
  
)

export default component.exports